import type { Match } from "navigo";
import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import type { Route, RouteContext } from "../router";
import { centeredBox } from "../van/centered-box";
import { button, div, h1, label, option, p, select } from "../van/van-tags";

export class Sp2CmdSetBeepPage implements Route {
	#onChangeEnabled(e: Event): void {
		if (!(e.target instanceof HTMLSelectElement)) return;
		this.#enabled = +e.target.value;
	}

	async #onClickSend(): Promise<void> {
		const req = this.#ctx.api.post(
			`/smartplug2s/${this.#reactive.imei}/cmds`,
		);
		req.setJsonBody({
			CmdData: {
				Enabled: this.#enabled,
			},
			CmdType: 0xa3,
		});
		req.setSignedInUserAuth();

		const res = await this.#ctx.loadingScreen.waitFor(req.do());
		if (res.ok) {
			this.#ctx.router.up();
		} else {
			this.#ctx.error.setText(await res.text());
		}
	}

	async refresh(match: Match): Promise<void> {
		if (!match.data?.imei) throw "missing path param: imei";
		this.#reactive.imei = match.data.imei;
	}

	#ctx: RouteContext;
	#enabled = 0;
	#reactive = reactive({
		imei: "",
	});

	ChildDom: ChildDom;

	constructor(ctx: RouteContext) {
		this.#ctx = ctx;
		this.ChildDom = centeredBox(
			{ size: "narrow" },
			h1({ class: "title is-4" }, "SmartPlug2 - Set Beep"),
			p({ class: "subtitle is-6" }, () => `IMEI ${this.#reactive.imei}`),
			div(
				{ class: "field" },
				label({ class: "label" }, "Enabled"),
				div(
					{ class: "control" },
					div(
						{ class: "select" },
						select(
							{
								onchange: (e: Event) =>
									this.#onChangeEnabled(e),
							},
							option({ value: "0" }, "0x00"),
							option({ value: "1" }, "0x01"),
						),
					),
				),
			),
			div(
				{ class: "buttons" },
				button(
					{
						class: "button is-primary",
						onclick: () => this.#onClickSend(),
					},
					"Send command",
				),
				button(
					{
						class: "button is-danger",
						onclick: () => this.#ctx.router.up(),
					},
					"Back",
				),
			),
		);
	}
}
